module.exports = __webpack_public_path__ + "img/ERIC_MISKA.0cb24617.png";